<template lang="html">

  <div class="cover-popup row-center">
      <div class="popup">

          <a @click="close" class="close">✕</a>

          <h2 class="title-pop">{{$t('image_uploader.titulo')}}</h2>

          <div class="magic-zone">

            
            <dropzone v-if="!!!img" @emit="setDoc" ref="dropzone" :onlyimg="true"></dropzone>
            
            
              <cropper v-if="!!img" classname="cropper" :src="img" :stencil-props="{
              aspectRatio: 1/1
          }" @change="change" :stencilComponent="$options.components.CircleStencil"></cropper>

          <loading :small="true"></loading>

          </div>

          <div class="contenedor-botones row-center">
          <button class="btn -solid-primary" v-if="!!img" @click="setImg">{{$t('guardar')}}</button>
              <button class="btn -skull-primary" v-if="!!img" @click="eraseImg">{{$t('eliminar')}}</button>
              <button class="btn -skull-primary" v-if="!img" @click="close">{{$t('cancelar')}}</button>
          </div>
      </div>
  </div>


</template>

<script lang="js">

  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);

  import { Cropper, CircleStencil } from 'vue-advanced-cropper'

  import {mapGetters} from 'vuex';


  import loading from '@/components/parts/loading';


  import dropzone from '@/components/parts/form/dropzone';

  export default {
      name: 'image-editor',
      props : ['avatarimg'],
      data() {
          return {
              img: '',
              imgb64: '',
              extension : ''
          }
      },
      methods: {
          setDoc(value) {
              this.img = value.ficheroB64ParaAltas;
              this.extension = value.extension_adjunto;
          },
          change({ coordinates, canvas }) {
              this.imgb64 = canvas.toDataURL();
          },
          eraseImg() {
              this.img = '';
              this.imgb64 = '';
          },
          setImg() {

            let data = {
              img : this.imgb64,
              extension : this.extension
            }

              this.$emit('setImg', data);
              this.close();
          },
          close() {
              this.$emit('close');
          }
      },
      components: {
        'dropzone': dropzone,
        'loading' : loading,
          Cropper,
          CircleStencil,
      },
      computed:{
        ...mapGetters({
          style : 'getStyles',
          colors : 'basicColors',
        })
      }
  }
</script>

<style scoped lang="scss">

  .popup{
    max-height: 80vh;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/parts/image-uploader.vue